module.exports = __webpack_public_path__ + "media/images/flags/ma-f8dfc14d7d7f08b9f5f2773908259ad4.svg";